module.exports = __webpack_public_path__ + "static/media/Aveny soffa D32R zink 3493 detalj 2023 2.948d507e.jpg";